import Box from '@mui/material/Box';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import { Close, WarningAmberOutlined } from '@mui/icons-material';
import Link from '@mui/material/Link';
import { SHIPPING_TO_USA } from '../../constants/routes';

const ShippingToUSAModal = ({ open, handleClose }) => (
  <Modal
    open={open}
    onClose={handleClose}
    aria-labelledby='usa-notice-title'
    aria-describedby='usa-notice-description'
  >
    <Card
      variant='elevation'
      sx={{
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        maxWidth: '500px',
        width: '100%',
      }}
      role='dialog'
    >
      <IconButton
        aria-label='close modal'
        sx={{ position: 'absolute', right: 5, top: 5, zIndex: 1 }}
        onClick={handleClose}
      >
        <Close />
      </IconButton>
      <CardHeader
        title={
          <Box display='flex' id='usa-notice-title'>
            <WarningAmberOutlined
              color='warning'
              sx={{ mr: 1 }}
              aria-hidden='true'
            />
            <Typography variant='h6' gutterBottom>
              Notice
            </Typography>
          </Box>
        }
      />
      <CardContent id='usa-notice-description'>
        <Typography variant='body1' gutterBottom>
          🇺🇲 Sending to the USA? It’s business as usual with DPD.
        </Typography>
        <Typography variant='body1' gutterBottom>
          <Link href={SHIPPING_TO_USA} target={'_blank'} rel='noreferrer'>
            Click here for more information on duties and taxes.
          </Link>
        </Typography>
      </CardContent>
      <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
        <Box>
          <Button variant='outlined' color='primary' onClick={handleClose}>
            Close
          </Button>
        </Box>
      </CardActions>
    </Card>
  </Modal>
);

export default ShippingToUSAModal;
